// Footer Component — replica el estilo del footer de LandingPage
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="flex items-center gap-2">
            <span className="rounded-lg bg-gradient-to-br from-emerald-500 to-teal-500 p-1 inline-flex shadow-sm shadow-emerald-500/20">
              <Zap className="h-3.5 w-3.5 text-white" />
            </span>
            <span className="text-sm font-extrabold tracking-tight text-gray-900 dark:text-gray-100">
              Proceso<span className="text-gradient">Fácil</span>
            </span>
          </span>
          <span className="text-xs text-gray-400 dark:text-gray-500">
            © {new Date().getFullYear()}
          </span>
        </div>
        <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
          <Link to="/terms" className="hover:text-gray-700 dark:hover:text-gray-300 transition-colors">
            Términos
          </Link>
          <Link to="/privacy" className="hover:text-gray-700 dark:hover:text-gray-300 transition-colors">
            Privacidad
          </Link>
        </div>
      </div>
    </footer>
  );
}
